var map = {
	"./de": 1753,
	"./de.json": 1753,
	"./en": 1754,
	"./en.json": 1754,
	"./es": 1755,
	"./es.json": 1755,
	"./fr": 1756,
	"./fr.json": 1756
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1752;